import Vue from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';
import getSeparatedList from '../../utils/getSeparatedList.js';

/**
 * Hey!
 *
 * STumblr component used for Tumblr social network
 * @link https://tumblr.com/
 */
/**
 * Share parameters for link
 * @link https://www.tumblr.com/docs/en/share_button
 */

var STumblr = /* #__PURE__ */Vue.extend({
  name: 'STumblr',
  mixins: [BaseSocials('Tumblr', {
    width: 542,
    height: 644
  })],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'https://www.tumblr.com/widgets/share/tool';
      var shareOptions = this.shareOptions;
      var canonicalUrl = shareOptions.canonicalUrl,
          tags = shareOptions.tags,
          title = shareOptions.title,
          caption = shareOptions.caption,
          content = shareOptions.content,
          showVia = shareOptions.showVia;
      var serialisedParams = getSerialisedParams({
        canonicalUrl: canonicalUrl,
        title: title,
        caption: caption,
        content: content,
        tags: getSeparatedList(tags),
        'show-via': showVia
      });
      return "".concat(BASE_URL).concat(serialisedParams);
    }
  },
  render: function render(h) {
    return this.generateComponent(h, this.networkURL);
  }
});

export default STumblr;
